const DATE_FORMAT = 'dd MMMM yyyy'

const DATE_FORMAT_SHORT = 'dd MMMM'

export { DATE_FORMAT, DATE_FORMAT_SHORT }
